import React, { Component } from 'react';
import styled from 'styled-components';
import { RADIUS } from 'common/constants/sizes';
import { Flex, Padding } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Text from './Text';

export const StyledInput = styled.input`
  border-radius: ${RADIUS.small};
  min-height: 2rem;
  min-width: 8rem;
  padding-left: 1rem;
  border: ${({ isError }) =>
    `1px solid ${getColor(isError ? 'torchRed' : 'botticelli')}`};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  font-size: 1.3rem;
  box-sizing: content-box;
`;

export default class Input extends Component {
  state = { value: '' };

  handleChange = event => {
    const { value } = event.target;
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  submit = () => {
    if (!this.props.onSubmit) {
      return;
    }

    this.props.onSubmit(this.state.value);
  };

  onKeyDown = event => {
    if (event.key === 'Enter') {
      this.submit(event);
    }
  };

  render() {
    const {
      icon,
      placeholder,
      value,
      width,
      height,
      disabled = false,
      isError = false,
      style = {},
      dataCy,
      type = 'text',
      maxLength = null,
      onFocus,
      onBlur,
      autoFocus = false
    } = this.props;
    return (
      <Flex items='center' width={width}>
        <StyledInput
          type={type}
          width={width}
          height={height}
          onChange={this.handleChange}
          placeholder={placeholder}
          onKeyDown={this.onKeyDown}
          value={value === undefined ? this.state.value : value}
          disabled={disabled}
          style={style}
          isError={isError}
          maxLength={maxLength}
          {...(dataCy ? { 'data-cy': dataCy } : {})}
          {...(onFocus ? { onFocus } : {})}
          {...(onBlur ? { onBlur } : {})}
          {...(autoFocus ? { autoFocus: true } : {})}
        />
        {icon ? <Padding l='small'>{icon}</Padding> : null}
      </Flex>
    );
  }
}

const withErrorDescription = WrappedComponent => props => {
  const { flex } = props;
  const ErrorDescription = styled(Text)`
    position: absolute;
    top: 3.7rem;
    color: ${getColor('torchRed')};
  `;
  return (
    <Flex flex={flex} position='relative'>
      <WrappedComponent {...props} />
      {props.isError && (
        <ErrorDescription>{props.errorDescription}</ErrorDescription>
      )}
    </Flex>
  );
};

export const InputWithErrorDescription = withErrorDescription(Input);
